import { DataModuleVO, DataVO } from '@edgvr-front/data/domain';

export class DataModuleFullStatCsvDMO {
  readonly data: string;

  constructor(data: DataVO, dataModule: DataModuleVO) {
    const examResults = dataModule.persons.length
      ? dataModule.persons[0].examResults.map((_) => _.Field.trim())
      : [];
    const customStats = dataModule.persons.length
      ? dataModule.persons[0].customStats.map((_) => _.Field.trim())
      : [];

    const header = [
      'Account Name',
      'Address',
      'Center Name',
      'Assessor First Name',
      'Assessor Middle Name',
      'Assessor Last Name',
      'Candidate First Name',
      'Candidate Middle Name',
      'Candidate Last Name',
      'Candidate DOB',
      'Workshop Name',
      'Total Score',
      'Score Percentage',
      'Start Date/Time',
      'Finish Date/Time',
      'Date Of Entry',
      'Module Name',
      'Module Type',
      ...customStats,
      ...examResults,
      'Student Device ID',
      'Student Device Model',
      'Student Version',
      'Host Device ID',
      'Host Device Model',
      'Host Version',
      'Session Type',
      'Session Device Swaps',
    ]
      .map((_) => (_.includes(',') ? `"${_}"` : _))
      .join(',');

    const rows = dataModule.persons.map((_) =>
      [
        data.accountName,
        data.address,
        data.centerName || '',
        data.assessorFirstName,
        data.assessorMiddleName || '',
        data.assessorLastName,
        _.firstName,
        _.middleName || '',
        _.lastName,
        new Date(_.dateOfBirth).toLocaleDateString('en-GB'),
        data.workshopName,
        _.score + '',
        ((_.score * 100) / dataModule.maxScore).toFixed(2),
        new Date(data.startedAt).toLocaleString('en-GB'),
        new Date(data.finishedAt).toLocaleString('en-GB'),
        new Date(data.entryAt).toLocaleString('en-GB'),
        dataModule.moduleName,
        dataModule.moduleType,
        ..._.customStats.map((_) => _.Value.trim()),
        ..._.examResults.map((_) => _.Value.trim()),
        _.deviceId,
        _.deviceModel,
        _.deviceVersion || '',
        data.hostDeviceId,
        data.hostDeviceModel,
        data.hostDeviceVersion,
        data.sessionType || '',
        data.sessionDeviceSwaps + '',
      ]
        .map((_) => (_.includes(',') ? `"${_}"` : _))
        .join(',')
    );

    this.data = [header, ...rows].join('\n');
  }
}
